/* ============================================================
   Bones Gourmet — Pantalla 3 (fase dinámica)
   Interactividad: galería, selector de variantes real (matching
   contra product.variants), stepper de cantidad, submit real al
   carrito, y cálculo del combo FBT.
   ============================================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    /* La tienda usa el formato "$ {{amount}}" (con espacio) — Dawn no expone
       Shopify.formatMoney en este tema, así que este fallback SIEMPRE es el
       que se usa. Debe calzar con ese formato o el precio "salta" (pierde el
       espacio) cada vez que JS lo actualiza, aunque el render inicial de
       Liquid sí lo traiga bien. */
    return '$ ' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  /* ----------------------------------------------------------
     Carrito — añadir sin salir de la página.
     El tema ya trae el cart-drawer nativo de Dawn activo
     (Configuración > Carrito > Tipo = "Drawer"), así que en vez
     de redirigir a /cart lo reutilizamos: se pide que la
     respuesta de cart/add.js incluya el HTML actualizado del
     drawer + del contador del header (mismo mecanismo que usa
     el <product-form> nativo de Dawn) y se le pide que se
     renderice y abra. Si por lo que sea no hay cart-drawer en
     la página, cae de vuelta a redirigir a /cart.
     ---------------------------------------------------------- */
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function showCartToast(message) {
    let toast = document.querySelector('.bones-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bones-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // reflow — reinicia la animación si ya estaba visible
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function addToCartAndOpenDrawer(items, toastMessage) {
    const cartDrawer = getCartDrawer();
    const body = { items };

    if (cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          return Promise.reject(data);
        }
        if (cartDrawer) {
          cartDrawer.renderContents(data);
          // renderContents() de Dawn no quita "is-empty" del elemento raíz
          // (solo de .drawer__inner) — sin esto el drawer se abre pero la
          // vista "carrito vacío" no cambia. Dawn lo hace en <product-form>.
          cartDrawer.classList.remove('is-empty');
          if (toastMessage) showCartToast(toastMessage);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
        fetchCartAndUpdateFreeShip();
        return data;
      });
  }

  /* ----------------------------------------------------------
     Card de "envío gratis" — 100% reactiva al carrito real.
     No basta con calcularla al cargar la página: si el
     comprador sube/baja cantidad o quita un producto DESDE EL
     DRAWER (sin recargar), debe actualizarse en el momento.
     Dawn publica PUB_SUB_EVENTS.cartUpdate (pubsub.js) cada vez
     que cart-items.js cambia algo en el carrito — nos
     enganchamos ahí en vez de reinventar la detección de
     cambios, y de paso volvemos a pedir /cart.js para tener el
     total real más reciente.
     ---------------------------------------------------------- */
  function updateFreeShipWidgets(cartTotalCents) {
    document.querySelectorAll('[data-bones-freeship]').forEach((widget) => {
      const threshold = parseInt(widget.dataset.thresholdCents, 10) || 0;
      const textEl = widget.querySelector('[data-freeship-text]');
      const fillEl = widget.querySelector('[data-freeship-fill]');
      if (!textEl || !fillEl || threshold <= 0) return;

      const remaining = Math.max(threshold - cartTotalCents, 0);
      const reached = remaining <= 0;
      let progress = Math.min((cartTotalCents / threshold) * 100, 100);
      if (progress > 0 && progress < 4) progress = 4;

      if (reached) {
        textEl.textContent = widget.dataset.successText;
      } else {
        textEl.innerHTML = widget.dataset.prefix
          + ' <strong class="bones-pdp-freeship__amount">' + formatMoney(remaining) + '</strong> '
          + widget.dataset.suffix;
      }
      fillEl.style.width = progress + '%';
    });
  }

  function fetchCartAndUpdateFreeShip() {
    if (!document.querySelector('[data-bones-freeship]')) return;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((res) => res.json())
      .then((cart) => updateFreeShipWidgets(cart.total_price))
      .catch(() => {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetchCartAndUpdateFreeShip();
    });
  }

  /* ----------------------------------------------------------
     Galería — clic en miniatura clona su contenido dentro del
     contenedor principal (funciona con <img> real o <svg>
     placeholder por igual).
     ---------------------------------------------------------- */
  function initGallery(root) {
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    const mainImg = root.querySelector('[data-pdp-main-image]');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc) {
          mainImg.innerHTML = '';
          const img = document.createElement('img');
          img.src = fullSrc;
          img.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
          mainImg.appendChild(img);
        } else {
          mainImg.innerHTML = thumb.innerHTML;
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----------------------------------------------------------
     Selector de variantes — empareja la combinación de opciones
     seleccionada contra la lista real de variantes (embebida
     como JSON por Liquid) y actualiza precio, id de variante y
     disponibilidad del botón de compra.
     ---------------------------------------------------------- */
  function initVariantPicker(root) {
    const groups = root.querySelectorAll('[data-pdp-option-group]');
    if (!groups.length) return;

    const variantsJsonEl = root.parentElement.querySelector('[data-pdp-variants-json]')
      || document.querySelector('[data-pdp-variants-json]');
    if (!variantsJsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      return;
    }

    const variantInput = root.querySelector('[data-pdp-variant-input]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const compareEl = root.querySelector('[data-pdp-price-compare]');
    const badgeEl = root.querySelector('[data-pdp-price-badge]');
    const badgePctEl = root.querySelector('[data-pdp-price-badge-pct]');
    const atcBtn = root.querySelector('[data-pdp-atc]');
    const atcLabel = root.querySelector('[data-pdp-atc-label]');

    function getSelections() {
      const selections = [];
      groups.forEach((group) => {
        const active = group.querySelector('.bones-pdp-variant.is-selected');
        const index = parseInt(group.dataset.optionIndex, 10);
        selections[index] = active ? active.dataset.value : null;
      });
      return selections;
    }

    function findMatch(selections) {
      return variants.find((v) =>
        v.options.length === selections.length &&
        v.options.every((opt, i) => opt === selections[i])
      );
    }

    function update() {
      const selections = getSelections();
      const match = findMatch(selections);
      if (!match) return;

      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      const onSale = match.compareAtPrice && match.compareAtPrice > match.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(match.compareAtPrice);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (badgeEl) {
        badgeEl.hidden = !onSale;
        if (onSale && badgePctEl) {
          const pct = Math.round(((match.compareAtPrice - match.price) / match.compareAtPrice) * 100);
          badgePctEl.textContent = pct;
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !match.available;
      }
      if (atcLabel) {
        atcLabel.textContent = match.available ? 'Añadir al Carrito' : 'Agotado';
      }

      /* Avisa a otras secciones de la página (ej. el combo FBT en
         Información Adicional) que la variante seleccionada cambió,
         para que puedan actualizar su propio gramaje/precio. */
      document.dispatchEvent(new CustomEvent('bones:variant-change', {
        detail: {
          productId: root.dataset.productId,
          productTitle: root.dataset.productTitle,
          variantId: match.id,
          price: match.price,
          weight: match.weight || null,
          available: match.available,
        },
      }));
    }

    groups.forEach((group) => {
      const buttons = group.querySelectorAll('[data-pdp-variant]');
      const labelEl = group.previousElementSibling
        ? group.previousElementSibling.querySelector('[data-pdp-option-label]')
        : null;

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          buttons.forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          if (labelEl) labelEl.textContent = btn.dataset.value;
          update();
        });
      });
    });
  }

  /* ----------------------------------------------------------
     Acordeones animados — <details> nativo abre/cierra de golpe
     (display:none no es animable). Se intercepta el click en
     <summary>, se anima la altura real del contenido vía JS y
     recién al terminar la transición se quita/pone el atributo
     "open".
     ---------------------------------------------------------- */
  function initAccordions(root) {
    const items = root.querySelectorAll('.bones-pdp-accordion');

    items.forEach((details) => {
      const summary = details.querySelector('.bones-pdp-accordion__summary');
      const body = details.querySelector('[data-accordion-body]');
      const inner = body ? body.querySelector('.bones-pdp-accordion__body-inner') : null;
      if (!summary || !body || !inner) return;

      body.style.height = details.hasAttribute('open') ? 'auto' : '0px';

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = details.hasAttribute('open');

        if (isOpen) {
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight; // fuerza reflow antes de animar a 0
          requestAnimationFrame(() => {
            body.style.height = '0px';
          });
          body.addEventListener('transitionend', function onEnd() {
            details.removeAttribute('open');
            body.removeEventListener('transitionend', onEnd);
          }, { once: true });
        } else {
          details.setAttribute('open', '');
          const target = inner.scrollHeight;
          body.style.height = '0px';
          void body.offsetHeight; // fuerza reflow antes de animar
          requestAnimationFrame(() => {
            body.style.height = target + 'px';
          });
          body.addEventListener('transitionend', function onEnd() {
            body.style.height = 'auto';
            body.removeEventListener('transitionend', onEnd);
          }, { once: true });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     Stepper de cantidad — sincroniza con el input oculto del
     formulario para que el submit real lleve la cantidad correcta.
     ---------------------------------------------------------- */
  function initQuantityStepper(root) {
    const minus = root.querySelector('[data-pdp-qty-minus]');
    const plus  = root.querySelector('[data-pdp-qty-plus]');
    const value = root.querySelector('[data-pdp-qty-value]');
    const input = root.querySelector('[data-pdp-qty-input]');
    if (!minus || !plus || !value) return;

    function getQty() {
      return parseInt(value.textContent, 10) || 1;
    }

    function setQty(n) {
      value.textContent = n;
      if (input) input.value = n;

      /* Avisa al combo FBT (fila "Este producto") para que su cantidad
         y precio de fila se mantengan iguales a los del formulario
         principal — antes quedaban desincronizados (ver bones:variant-change
         para el mismo patrón aplicado al gramaje). */
      document.dispatchEvent(new CustomEvent('bones:qty-change', {
        detail: { productId: root.dataset.productId, quantity: n },
      }));
    }

    minus.addEventListener('click', () => setQty(Math.max(1, getQty() - 1)));
    plus.addEventListener('click', () => setQty(getQty() + 1));
  }

  /* ----------------------------------------------------------
     Formulario de compra — submit real vía cart/add.js
     ---------------------------------------------------------- */
  function initBuyForm(root) {
    const form = root.querySelector('#bones-pdp-form') || root.querySelector('.bones-pdp-form');
    const atcBtn = root.querySelector('[data-pdp-atc]');
    if (!form || !atcBtn) return;

    const productTitle = root.dataset.productTitle || 'Producto';

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (atcBtn.disabled) return;

      const variantId = form.querySelector('[name="id"]').value;
      const qtyInput = form.querySelector('[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      const original = atcBtn.innerHTML;
      atcBtn.disabled = true;
      const label = atcBtn.querySelector('[data-pdp-atc-label]');
      if (label) label.textContent = 'Agregando...';

      addToCartAndOpenDrawer([{ id: variantId, quantity }], `${productTitle} añadido al carrito`)
        .catch((err) => {
          // Shopify devuelve status + description en caso de error (ej. sin stock)
          console.error(err);
        })
        .finally(() => {
          atcBtn.disabled = false;
          atcBtn.innerHTML = original;
        });
    });
  }

  /* ----------------------------------------------------------
     FBT — checkboxes, cantidad por producto, gramaje seleccionable
     en ambas filas, disponibilidad y total en tiempo real.

     "Este producto" reutiliza el <select> de gramaje y los botones
     +/- de cantidad del hero (dispara clicks sobre ellos en vez de
     llevar su propio estado), así el precio/oferta/botón de compra
     de arriba quedan siempre sincronizados con la fila del combo,
     en cualquier dirección, para el mismo producto en la misma página.
     ---------------------------------------------------------- */
  function initFbt(root) {
    const checkboxes = root.querySelectorAll('.bones-pdp-fbt__cb');
    const totalEl     = root.querySelector('[data-fbt-total]');
    const countEl     = root.querySelector('[data-fbt-count]');
    const addBtn      = root.querySelector('[data-fbt-add]');

    if (!checkboxes.length || !addBtn) return;

    function getRowQty(row) {
      const el = row.querySelector('[data-fbt-qty-value]');
      return el ? parseInt(el.textContent, 10) || 1 : 1;
    }

    function updateRowPrice(row) {
      const cb = row.querySelector('.bones-pdp-fbt__cb');
      const priceEl = row.querySelector('.bones-pdp-fbt__price');
      if (!cb || !priceEl) return;
      const unit = parseInt(cb.dataset.price || 0, 10);
      priceEl.textContent = formatMoney(unit * getRowQty(row));
    }

    function setRowQty(row, n) {
      const el = row.querySelector('[data-fbt-qty-value]');
      if (el) el.textContent = Math.max(1, n);
      updateRowPrice(row);
      update();
    }

    function setRowAvailability(row, available) {
      const cb = row.querySelector('.bones-pdp-fbt__cb');
      const priceEl = row.querySelector('.bones-pdp-fbt__price');
      let badge = row.querySelector('.bones-pdp-fbt__unavailable');

      if (!available) {
        if (cb) {
          cb.checked = false;
          cb.disabled = true;
        }
        if (priceEl) priceEl.hidden = true;
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bones-pdp-fbt__unavailable';
          badge.textContent = 'Agotado';
          if (priceEl) priceEl.insertAdjacentElement('afterend', badge);
        }
        badge.hidden = false;
      } else {
        if (cb) cb.disabled = false;
        if (priceEl) priceEl.hidden = false;
        if (badge) badge.hidden = true;
      }
    }

    function checked() {
      return Array.from(checkboxes).filter((cb) => cb.checked);
    }

    function update() {
      const sel = checked();
      const total = sel.reduce((s, cb) => {
        const row = cb.closest('.bones-pdp-fbt__item');
        return s + parseInt(cb.dataset.price || 0, 10) * getRowQty(row);
      }, 0);

      /* La tarjeta cambia de color según esté marcada o no — sin esto el
         único indicador de "incluido en el carrito" era el checkbox
         chiquito, que pasaba desapercibido. */
      checkboxes.forEach((cb) => {
        const row = cb.closest('.bones-pdp-fbt__item');
        if (row) row.classList.toggle('is-selected', cb.checked);
      });

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (countEl) countEl.textContent = sel.length;
      addBtn.disabled = sel.length === 0;
    }

    checkboxes.forEach((cb) => cb.addEventListener('change', update));

    /* ----- Fila "Este producto": select + cantidad propios, ambos
       sincronizados con el formulario principal del hero (misma idea
       que el gramaje: el hero es la única fuente de verdad para ESE
       producto, la fila del combo solo refleja/dispara sus controles
       en vez de llevar un estado de cantidad independiente). ----- */
    const currentRow = root.querySelector('[data-fbt-current]');
    if (currentRow) {
      const productId = currentRow.dataset.productId;
      const currentSelect = currentRow.querySelector('[data-fbt-current-select]');
      const heroRoot = document.querySelector('[data-bones-pdp-hero][data-product-id="' + productId + '"]');

      document.addEventListener('bones:variant-change', (event) => {
        const detail = event.detail || {};
        if (String(detail.productId) !== String(productId)) return;

        const cb = currentRow.querySelector('.bones-pdp-fbt__cb');
        if (cb) {
          cb.dataset.variantId = detail.variantId;
          cb.dataset.price = detail.price;
        }
        if (currentSelect && detail.weight) {
          const raw = detail.weight.replace(/gr$/, '');
          if (currentSelect.value !== raw) currentSelect.value = raw;
        }
        setRowAvailability(currentRow, detail.available !== false);
        updateRowPrice(currentRow);
        update();
      });

      document.addEventListener('bones:qty-change', (event) => {
        const detail = event.detail || {};
        if (String(detail.productId) !== String(productId)) return;
        setRowQty(currentRow, detail.quantity);
      });

      if (currentSelect) {
        currentSelect.addEventListener('change', () => {
          if (!heroRoot) return;
          const btn = heroRoot.querySelector('[data-pdp-variant][data-value="' + currentSelect.value + '"]');
          if (btn) btn.click();
        });
      }

      const currentQtyBox = currentRow.querySelector('[data-fbt-qty]');
      if (currentQtyBox && heroRoot) {
        const currentQtyMinus = currentQtyBox.querySelector('[data-fbt-qty-minus]');
        const currentQtyPlus = currentQtyBox.querySelector('[data-fbt-qty-plus]');
        if (currentQtyMinus) {
          currentQtyMinus.addEventListener('click', () => {
            const heroMinus = heroRoot.querySelector('[data-pdp-qty-minus]');
            if (heroMinus) heroMinus.click();
          });
        }
        if (currentQtyPlus) {
          currentQtyPlus.addEventListener('click', () => {
            const heroPlus = heroRoot.querySelector('[data-pdp-qty-plus]');
            if (heroPlus) heroPlus.click();
          });
        }
        // arranca igualado por si el hero no partió en 1 (ej. back/forward del navegador)
        const heroQtyValue = heroRoot.querySelector('[data-pdp-qty-value]');
        if (heroQtyValue) setRowQty(currentRow, parseInt(heroQtyValue.textContent, 10) || 1);
      }
    }

    /* ----- Steppers de cantidad — fila(s) de producto complementario.
       La fila "Este producto" se excluye: sus botones están cableados
       arriba para disparar los del hero en vez de llevar su propio
       estado. ----- */
    root.querySelectorAll('[data-fbt-qty]').forEach((qtyBox) => {
      const row = qtyBox.closest('.bones-pdp-fbt__item');
      if (row === currentRow) return;
      const minus = qtyBox.querySelector('[data-fbt-qty-minus]');
      const plus = qtyBox.querySelector('[data-fbt-qty-plus]');
      if (minus) minus.addEventListener('click', () => setRowQty(row, getRowQty(row) - 1));
      if (plus) plus.addEventListener('click', () => setRowQty(row, getRowQty(row) + 1));
    });

    /* ----- Selects de gramaje para productos complementarios ----- */
    root.querySelectorAll('[data-fbt-complement]').forEach((row) => {
      const select = row.querySelector('[data-fbt-variant-select]');
      if (!select) return;

      const productId = row.dataset.productId;
      const jsonEl = root.querySelector('[data-fbt-variants-json][data-for="' + productId + '"]');
      if (!jsonEl) return;

      let variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      select.addEventListener('change', () => {
        const match = variants.find((v) => v.weight === select.value);
        if (!match) return;

        const cb = row.querySelector('.bones-pdp-fbt__cb');
        if (cb) {
          cb.dataset.variantId = match.id;
          cb.dataset.price = match.price;
        }
        setRowAvailability(row, match.available);
        updateRowPrice(row);
        update();
      });
    });

    addBtn.addEventListener('click', () => {
      const sel = checked();
      if (!sel.length) return;

      const items = sel.map((cb) => {
        const row = cb.closest('.bones-pdp-fbt__item');
        return { id: cb.dataset.variantId, quantity: getRowQty(row) };
      });

      addBtn.disabled = true;
      const orig = addBtn.textContent;
      addBtn.textContent = 'Agregando...';

      const totalUnits = items.reduce((s, it) => s + it.quantity, 0);
      const label = totalUnits > 1 ? `${totalUnits} productos añadidos al carrito` : 'Producto añadido al carrito';

      addToCartAndOpenDrawer(items, label)
        .catch((err) => console.error(err))
        .finally(() => {
          addBtn.disabled = false;
          addBtn.textContent = orig;
        });
    });

    update();
  }

  /* ----------------------------------------------------------
     Init
     ---------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-bones-pdp-hero]').forEach((root) => {
      initGallery(root);
      initVariantPicker(root);
      initQuantityStepper(root);
      initBuyForm(root);
    });
    document.querySelectorAll('[data-bones-pdp-extra]').forEach(initAccordions);
    document.querySelectorAll('[data-bones-pdp-fbt]').forEach(initFbt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
